/**
 * 
 */
class BlockImageVideoManager {

	/**
	 * @type HTMLElement
	 */
	fullScreenElement = null;

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onFullScreenChange = this.onFullScreenChange.bind( this );
		document.addEventListener( 'fullscreenchange', this.onFullScreenChange );
	}

	/**
	 * 
	 */
	onFullScreenChange( event )
	{
		/**
		 * @type HTMLElement
		 */
		let fullScreenElement = null;

		if ( document.fullscreenElement )
		{
			fullScreenElement = document.fullscreenElement;
		}
		else if ( document.mozFullScreenElement )
		{
			fullScreenElement = document.mozFullScreenElement;
		}
		else if ( document.msFullscreenElement )
		{
			fullScreenElement = document.msFullscreenElement;
		}
		else if ( document.webkitFullscreenElement )
		{
			fullScreenElement = document.webkitFullscreenElement;
		}
		
		/**
		 * Enter fullscreen
		 */
		if ( fullScreenElement )
		{
			if ( fullScreenElement.classList.contains( 'wmu-media-object' ) )
			{
				fullScreenElement.style.objectFit = 'contain';
				this.fullScreenElement = fullScreenElement;
			}
		}

		/**
		 * Exit fullscreen
		 */
		else
		{
			if ( this.fullScreenElement )
			{
				this.fullScreenElement.style.objectFit = '';
				this.fullScreenElement = null;
			}
		}
	}

}

export default BlockImageVideoManager;